import { uniqBy } from 'lodash'
import { getModalUrl } from 'lib/modals'

export const EVENT_TYPE = Object.freeze({
    INSPECTION: 'INSPECTION',
    SERVICE: 'SERVICE',
    REFILL: 'REFILL',
    SYSTEM: 'SYSTEM',
    OTHER: 'OTHER',
})

export const USER_SELECTABLE_EVENT_TYPES = Object.freeze([
    EVENT_TYPE.INSPECTION,
    EVENT_TYPE.SERVICE,
    EVENT_TYPE.REFILL,
    EVENT_TYPE.OTHER,
])

export const REMINDER_EVENT_TYPES = Object.freeze([
    EVENT_TYPE.INSPECTION,
    EVENT_TYPE.SERVICE,
    EVENT_TYPE.OTHER,
])

export const SYSTEM_EVENT_TYPE = Object.freeze({
    VEHICLE_ADDED: 'VEHICLE_ADDED',
    STATUS_SET_OLD: 'STATUS_SET_OLD',
    STATUS_SET_SOLD: 'STATUS_SET_SOLD',
    STATUS_SET_ACTIVE: 'STATUS_SET_ACTIVE',
    PRICE_ESTIMATE: 'PRICE_ESTIMATE',
    BOS_VEHICLE_BOUGHT: 'BOS_VEHICLE_BOUGHT',
    BOS_VEHICLE_SOLD: 'BOS_VEHICLE_SOLD',
    VEHICLE_PURCHASED: 'VEHICLE_PURCHASED',
    NEW_SALES_AD: 'NEW_SALES_AD',
    AD_STATUS_CHANGE: 'AD_STATUS_CHANGE',
})

export const SYSTEM_EVENT_ICON_COLORS = Object.freeze({
    GREEN: 'rgb(127, 166, 20)',
    BLUE: 'rgb(104, 135, 169)',
    RED: 'rgb(204, 0, 0)',
    ORANGE: 'rgb(217, 157, 26)'
})

export const DEFAULT_EVENT_TYPE = EVENT_TYPE.OTHER

export const EVENT_REMINDER_UNITS = Object.freeze({
    MINUTES: 'MINUTES',
    HOURS: 'HOURS',
    DAYS: 'DAYS',
    WEEKS: 'WEEKS',
    MONTHS: 'MONTHS',
})

export const EVENT_REMINDER_OPTIONS = Object.freeze([
    { value: '1 HOURS', unit: EVENT_REMINDER_UNITS.HOURS, unitAmount: 1 },
    { value: '6 HOURS', unit: EVENT_REMINDER_UNITS.HOURS, unitAmount: 6 },
    { value: '1 DAYS', unit: EVENT_REMINDER_UNITS.DAYS, unitAmount: 1 },
    { value: '2 DAYS', unit: EVENT_REMINDER_UNITS.DAYS, unitAmount: 2 },
    { value: '1 WEEKS', unit: EVENT_REMINDER_UNITS.WEEKS, unitAmount: 1 },
    { value: '2 WEEKS', unit: EVENT_REMINDER_UNITS.WEEKS, unitAmount: 2 },
    { value: '1 MONTHS', unit: EVENT_REMINDER_UNITS.MONTHS, unitAmount: 1 },
])

export const SERVICE_EVENT_TYPE = {
    ANNUAL_MAINTENANCE: 'ANNUAL_MAINTENANCE',
    SCHEDULED_MAINTENANCE: 'SCHEDULED_MAINTENANCE',
    OIL_CHANGE: 'OIL_CHANGE',
    REPAIR: 'REPAIR',
    TIRE_CHANGE: 'TIRE_CHANGE',
    CAR_WASH: 'CAR_WASH',
    OTHER: 'OTHER',
}

export const getEventReminderOptions = (t) => {
    return EVENT_REMINDER_OPTIONS.map(reminder => {
        return {
            ...reminder,
            name: eventReminderLabel(t, reminder),
        }
    })
}

export const getEventModalUrl = (location, formMode, vehicleId, eventTypeOrId) => {
    return getModalUrl(location, `tapahtuma/${formMode.toLowerCase()}/${vehicleId}/${eventTypeOrId.toLowerCase()}`)
}

export const getEventTypeSelectModalUrl = (location, vehicleId) => {
    return getModalUrl(location, `muistutustapa/${vehicleId}`)
}

export const eventReminderLabel = (t, reminder) => {
    return reminder.unitAmount > 1
        ? t(`events:reminders.options.units.${reminder.unit.toLowerCase()}_plural`, { amount: reminder.unitAmount })
        : t(`events:reminders.options.units.${reminder.unit.toLowerCase()}`, { amount: reminder.unitAmount })
}

export const sortByEventTime = (moment) => (a, b) => {
    if (moment(a.eventTime).isBefore(moment(b.eventTime))) {
        return 1
    }
    if (moment(a.eventTime).isAfter(moment(b.eventTime))) {
        return -1
    }
    return 0
}

export const updateEventCacheMerge = (events) => {
    const newEvents = events.map((event) => ({
        __ref: `Event:${event.id}`
    }))

    return (existing) => {
        return {
            ...existing,
            events: uniqBy(
                [
                    ...existing.events,
                    ...newEvents,
                ],
                '__ref'
            ),
        }
    }
}

export const updateEventCacheMergeAndModify = (cache, events) => {
    cache.modify({
        fields: {
            events: updateEventCacheMerge(events)
        }
    })
}
